import React from 'react';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import { AllImageSizes, getImageUrl } from '@domain-group/fe-allhomes-library';
import { PhotoIcon } from '@domain-group/fe-co-icon';
import * as styles from './multiple-listing-card-image.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var MultipleListingCardImage = props => {
  var isDefault = !props.firstImage;
  return ___EmotionJSX("div", {
    css: styles.image({
      isDefault
    })
  }, ___EmotionJSX("span", null, props.firstImage ? ___EmotionJSX(MultiResolutionImage, {
    css: styles.square({
      isDefault
    }),
    src: getImageUrl(props.firstImage, AllImageSizes.LARGE),
    alt: props.alt
  }) : ___EmotionJSX("div", {
    css: styles.square({
      isDefault
    })
  }, ___EmotionJSX("div", null, ___EmotionJSX(PhotoIcon, {
    size: "regular"
  })), ___EmotionJSX("div", {
    css: styles.text
  }, "Image not available"))));
};